module.exports = __webpack_public_path__ + "static/media/test-audio.3a35be11.mp3";